import events from "@/components/events/events.vue"
import cam_test from '@/components/cam_test.vue'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
export default {
	name 		: "parking",
	components 	: {
		events,
		cam_test
	}, //components
	props : [
		"info_to_component",
		"ref_to_component",
		"layout_id",
		"layout",
	],
	data : (vm) => ({
		info_counters 	: {
			
			total_invoice : {
				key 	: "total_invoice",
				text 	: vm.$ml.get("total_invoice"),
				count 	: 0,
				color 	: "",
				class   : "caption success pa-0",
				col 	: 2,
			},
			invoice_counter 	: {
				key 	: "invoice_counter",
				text 	: vm.$ml.get("invoice_counter"),
				total 	: 0,
				count 	: 0,
				color 	: "",
				class 	: "caption primary pa-0",
				col 	: 2,
			},
			
		},
		heads 			: {
			title 	: vm.$ml.get('register'), 
			title1 	: vm.$ml.get("parking"), 
			icon 	: "mdi-cash-register"
		},
		show 			: {
			search 	: false,
			close 	: true,
		},
		list_show 		: [],
		ref 			: "",
		ID_notification : "",
		action_comp 	: {},
		height_counters : "100px",
		height_events  	: 200,
		offsetTop 		: 0,
		recording_states: {}, // Estado de grabación por deviceId
		editDialog: {
			visible: false,
			deviceId: null,
			type: '', // 'start' o 'end'
			value: '',
			menu: false
		},
		camVisibility: {}, // Estado de visibilidad de cam_test por deviceId
		countingAnimation: {}, // Estado de animación de conteo por deviceId
		detectedObjects: {}, // Información de objetos detectados por deviceId
		tagCounters: {}, // { [deviceId]: { [tag]: { in: 0, out: 0 } } } - Contadores por dispositivo
		tagMap: {}, // Mapeo auxiliar para tags de prueba por deviceId
		deviceTags: {}, // { [deviceId]: [tags] } - Tags independientes por dispositivo
		imageHistory: {}, // { [deviceId]: [{img, bbox, direction}] }
		imageTransition: {}, // { [deviceId]: { animating: false, direction: 'in'|'out' } }
		// NUEVO: Estado de animación especial
		finishingAnimation: {}, // { [deviceId]: true/false }
		startingAnimation: {}, // { [deviceId]: true/false }
		finishingLock: {},
		// NUEVO: Selector de cámaras
		showCameraSelector: false, // Mostrar/ocultar selector de cámaras
		selectedCameras: [], // Array de deviceIds de cámaras seleccionadas
		cameraSearch: '',
	}), // data
	// currentUser && currentUser.user.roleId < 3 && 
	created(){
		this.ref = this.ref_to_component;
		// this.render_counters();
		if (this.$route && this.$route.name.includes("dashboard")) {
    		let modul = this.$store.getters["auth/permission"]("dashboard");    		
    		if (!modul.can_edit) {
    			this.show.close 		= false
    		}
    	}
		
		//console.log('🔄 [PARKING-CREATED] Iniciando restauración desde localStorage...');
		
		const saved = localStorage.getItem('parking_recording_states');
		if (saved) {
			this.recording_states = JSON.parse(saved);
			//console.log('✅ [PARKING-CREATED] recording_states restaurado:', Object.keys(this.recording_states).length, 'sesiones');
		} else {
			//console.log('⚠️ [PARKING-CREATED] No se encontró parking_recording_states en localStorage');
		}
		
		// Restaurar tagCounters si existe
		const savedTagCounters = localStorage.getItem('parking_tag_counters');
		if (savedTagCounters) {
			this.tagCounters = JSON.parse(savedTagCounters);
			//console.log('✅ [PARKING-CREATED] tagCounters restaurado para', Object.keys(this.tagCounters).length, 'dispositivos');
		} else {
			this.tagCounters = {};
			//console.log('⚠️ [PARKING-CREATED] No se encontró parking_tag_counters, inicializando vacío');
		}

		// Restaurar deviceTags si existe
		const savedDeviceTags = localStorage.getItem('parking_device_tags');
		if (savedDeviceTags) {
			this.deviceTags = JSON.parse(savedDeviceTags);
			//console.log('✅ [PARKING-CREATED] deviceTags restaurado para', Object.keys(this.deviceTags).length, 'dispositivos');
		} else {
			this.deviceTags = {};
			//console.log('⚠️ [PARKING-CREATED] No se encontró parking_device_tags, inicializando vacío');
		}

		// Restaurar cámaras seleccionadas si existe
		const savedSelectedCameras = localStorage.getItem('parking_selected_cameras');
		if (savedSelectedCameras) {
			this.selectedCameras = JSON.parse(savedSelectedCameras);
		} else {
			this.selectedCameras = [];
		}

		// --- LIMPIEZA: Si no hay ninguna sesión activa, borra todos los tagCounters y deviceTags ---
		const hasActiveSession = Object.values(this.recording_states).some(state => state && state.startedAt && !state.endedAt);
		//console.log('🔍 [PARKING-CREATED] hasActiveSession (local):', hasActiveSession, '- Se validará con backend en mounted()');
		
		if (!hasActiveSession) {
			//console.log('🧹 [PARKING-CREATED] No hay sesiones activas locales, limpiando contadores...');
			this.tagCounters = {};
			this.deviceTags = {};
			localStorage.setItem('parking_tag_counters', JSON.stringify({}));
			localStorage.setItem('parking_device_tags', JSON.stringify({}));
		}
		
		this.tagMap = {};
		const devices = this.$store.getters["Devices/list"];
		//console.log('🔍 [PARKING-CREATED] Dispositivos del store:', devices.length);
		devices.forEach(d => {
			if (typeof this.camVisibility[d.deviceId] === 'undefined') {
				this.$set(this.camVisibility, d.deviceId, true);
			}
			// Ya no poblar device.tags desde localStorage
		});
		
		//console.log('✅ [PARKING-CREATED] Creación completada - La validación del backend se ejecutará en mounted()');
	},
		
	watch:{
		recording_states: {
			handler(val) {
				localStorage.setItem('parking_recording_states', JSON.stringify(val));
			},
			deep: true
		},
		layout:function(v){
			this.onResize();
		}, //layout

		// Sincronizar camVisibility local cuando cambie el store
		storeCamVisibility: function(newVal) {
			if (newVal && Object.keys(newVal).length > 0) {
				// Sincronizar el estado local con el store
				Object.entries(newVal).forEach(([deviceId, value]) => {
					this.$set(this.camVisibility, deviceId, value);
				});
			}
		},

		/*options:{
			handler(){
				if (!this.search  && !this.is_reports ) {
					this.get_list();
				}
				// console.log(this.search, 'searching options')
				if (this.search) {
					// this.get_search(this.search);
				}
				
			},
			deep: true,
		}, //options*/
		tagCounters: {
			handler(val) {
				localStorage.setItem('parking_tag_counters', JSON.stringify(val));
			},
			deep: true
		},
		deviceTags: {
			handler(val) {
				localStorage.setItem('parking_device_tags', JSON.stringify(val));
			},
			deep: true
		},
		selectedCameras: {
			handler(val) {
				localStorage.setItem('parking_selected_cameras', JSON.stringify(val));
			},
			deep: true
		},
	}, // 

	computed :{
		devices() {
		  // Solo dispositivos tipo IP_CAM
		  return this.$store.getters["Devices/list"].filter(d => d.type === 'IP_CAM');
		},
		filteredDevices() {
			// Si no hay cámaras seleccionadas, mostrar todas
			if (!this.selectedCameras || this.selectedCameras.length === 0) {
				return this.devices;
			}
			// Mostrar solo las seleccionadas
			return this.devices.filter(device => this.selectedCameras.includes(device.deviceId));
		},
		allCamsVisible() {
			return this.devices.every(d => this.isCamVisible(d.deviceId));
		},
		// Computed property para sincronizar camVisibility del store
		storeCamVisibility() {
			return this.$store.getters["Dashboard/camVisibility"] || {};
		}
	}, // computed

	methods : {
		actions(act, item, opt){
			if (act == "update_of_component") {
				this.$emit("update_of_component", { ...item});
			}else if(act == "close_component"){
				this.$emit('close_component', this.layout_id);
			}else if (act == "update_counter") {
					// console.log("counters **************** ", item)

				let { deviceId , invoice, name } = item; 
				if (!this.info_counters[deviceId]) {
					this.info_counters[deviceId] = {
						col 	: name && name.length > 15 ? 3 : 2,
						count 	: 0,
						key   	: deviceId,
						text  	: name,
						class 	: "caption secondary pa-0",
					}
				}
				this.info_counters[deviceId].count ++;
				this.info_counters.total_invoice.count += invoice;
				this.info_counters.invoice_counter.count ++;

			}
			
		}, // actions

		get_list(){

		}, // get list

		onScroll (e) {
        	this.offsetTop = e.target.scrollTop
     	}, // onScroll

     	onResize(){
     		if (this.$refs && this.$refs['card_parking' + this.layout_id] && this.$refs['card_parking' + this.layout_id].clientHeight) {
     			
				this.height_events = this.$refs['card_parking' + this.layout_id].clientHeight - (parseInt(this.height_counters) - 5)  ;
     		}
     	}, // inResize

		startDevice(device) {
			// Aquí va la lógica para iniciar el device
			// Por ejemplo, puedes emitir un evento o llamar a una acción Vuex
			this.$emit('start-device', device);
			// O implementar la lógica que necesites
			// console.log('Start device', device);
		},
		endDevice(device) {
			// Aquí va la lógica para finalizar el device
			this.$emit('end-device', device);
			// console.log('End device', device);
		},
		newDevice(device) {
			// Aquí va la lógica para el botón New
			this.$emit('new-device', device);
			// console.log('New device', device);
		},
		isRecording(deviceId) {
			const state = this.recording_states[deviceId];
			return !!(state && state.startedAt && !state.endedAt);
		},
		async getRuleIdForTag(tag) {
			// Busca el ruleId para un tag usando el store
			const smartEvents = this.$store.getters['Tags/getBySelect'] && this.$store.getters['Tags/getBySelect']('smart_event')?.list;
			if (smartEvents && Array.isArray(smartEvents)) {
				const found = smartEvents.find(ev => ev.name && ev.name.toLowerCase() === tag.toLowerCase());
				return found ? found.id : null;
			}
			return null;
		},
		async validateCountersWithBackend(device) {
			// Valida los contadores locales contra el backend para todos los tags activos
			const state = this.recording_states[device.deviceId];
			const tags = Array.isArray(this.deviceTags[device.deviceId]) ? this.deviceTags[device.deviceId] : [];
			console.log('🔍 [VALIDATION] Validando tags para device', device.deviceId, 'Tags:', tags);

			const start = state && state.startedAt ? formatForBackend(state.startedAt) : null;
			const end = formatForBackend(new Date());
			let allMatch = true;
			let mismatches = [];
			const apiStats = this.$URL + '/api/v1/alerts/stats';

			for (const tag of tags) {
				if (!tag || typeof tag !== 'string') continue;
				const ruleId = await this.getRuleIdForTag(tag);
				if (!ruleId) {
					console.log('⚠️ [VALIDATION] No se encontró ruleId para tag:', tag);
					continue;
				}
				const info = {
					deviceId: [device.deviceId], // ahora es array
					ruleId,
					tag, // enviar el nombre del tag explícitamente
					analytic: 'smart_event',
					timeZone: this.$timezone,
					start,
					end
				};
				console.log('📡 [VALIDATION] Enviando request para tag:', tag, 'Info:', info);

				let backendTotal = 0;
				try {
					const res = await this.$axios.post(apiStats, info);
					console.log('📡 [VALIDATION] Respuesta del backend para tag:', tag, 'Response:', res.data);
					if (res && res.data && Array.isArray(res.data.rows)) {
						// Buscar el deviceId en la respuesta
						const row = res.data.rows.find(r => r.deviceId === device.deviceId);
						if (row && row.subtotal !== undefined) {
							backendTotal = parseInt(row.subtotal) || 0;
						} else {
							backendTotal = 0; // No hay eventos en el backend
						}
					}
				} catch (e) {
					console.error('❌ [VALIDATION] Error validando tag', tag, 'Error:', e);
					this.$EventBus && this.$EventBus.$emit('notifications_modal', {
						type: 'error',
						message: `Error validating tag ${tag} with backend.`
					});
					allMatch = false;
					continue;
				}
				// Actualiza el contador local si es diferente al backend
				if ((this.tagCounters[device.deviceId] && this.tagCounters[device.deviceId][tag]?.in || 0) !== backendTotal) {
					if (!this.tagCounters[device.deviceId]) {
						this.$set(this.tagCounters, device.deviceId, {});
					}
					if (!this.tagCounters[device.deviceId][tag]) {
						this.$set(this.tagCounters[device.deviceId], tag, { in: 0, out: 0 });
					}
					this.tagCounters[device.deviceId][tag].in = backendTotal;
					// Opcional: notifica si se actualizó a 0
					if (backendTotal === 0) {
						this.$EventBus && this.$EventBus.$emit('notifications_modal', {
							type: 'info',
							message: `No se encontraron eventos para el tag "${tag}" en el backend. El contador se ha actualizado a 0.`
						});
					}
				}
				console.log('📊 [VALIDATION] Comparando tag:', tag, 'Local:', this.tagCounters[device.deviceId] && this.tagCounters[device.deviceId][tag]?.in || 0, 'Backend:', backendTotal);
				if ((this.tagCounters[device.deviceId] && this.tagCounters[device.deviceId][tag]?.in || 0) !== backendTotal) {
					allMatch = false;
					mismatches.push({ tag, local: this.tagCounters[device.deviceId] && this.tagCounters[device.deviceId][tag]?.in || 0, backend: backendTotal });
				}
			}
			console.log('✅ [VALIDATION] Resultado final:', { allMatch, mismatches });
			return { allMatch, mismatches };
		},
		toggleRecording(device) {
			const id = device.deviceId;
			const api = this.$URL + '/api/v1/operationsession';

			// BLOQUEO: Si ya está finalizando, no permitir más clicks
			if (this.finishingLock[id]) return;

			if (this.isRecording(id)) {
				this.$set(this.finishingLock, id, true); // Bloquear
				// --- ANIMACIÓN DE FINALIZACIÓN ---
				this.$set(this.finishingAnimation, id, true);
				// Cambiar imagen a negro (fondo)
				this.$set(device, 'lastSmartEventImg', null);
				setTimeout(async () => {
					this.$set(this.finishingAnimation, id, false);
					// --- Validación de contadores con backend usando barcode ---
					console.log('🔍 [TOGGLE-RECORDING] Iniciando validación por barcode antes de finalizar sesión');
					const validation = await this.validateCurrentSession(id);
					
					if (!validation.success) {
						console.error('❌ [TOGGLE-RECORDING] Error en validación por barcode:', validation.message);
						this.$EventBus && this.$EventBus.$emit('notifications_modal', {
							type: 'error',
							message: `Error validando contadores: ${validation.message}`
						});
						this.$set(this.finishingLock, id, false); // Desbloquear si hay error
						return; // No continuar si hay error
					}
					
					// Verificar si hay diferencias significativas
					const hasSignificantDifferences = validation.results && validation.results.some(result => 
						!result.allMatch && result.mismatches.some(mismatch => 
							Math.abs(mismatch.local.in - mismatch.backend.in) > 0 || 
							Math.abs(mismatch.local.out - mismatch.backend.out) > 0
						)
					);
					
					if (hasSignificantDifferences) {
						console.log('⚠️ [TOGGLE-RECORDING] Se encontraron diferencias, pero los contadores fueron sincronizados automáticamente');
						// Los contadores ya fueron actualizados en validateCurrentSession, continuar con la finalización
					} else {
						console.log('✅ [TOGGLE-RECORDING] Contadores validados correctamente');
					}
					
					// --- El resto del flujo va aquí, después de la animación y validación ---
					if (this.recording_states[id]) {
						this.$set(this.recording_states[id], 'endedAt', new Date());
						
						// Emitir evento para notificar que se detuvo la grabación
						this.$EventBus.$emit('parking_recording_state_changed', {
							deviceId: id,
							recordingState: this.recording_states[id],
							action: 'stop'
						});
						
						this.generatePdf(device);
						this.$axios.post(api, {
							barcode: this.recording_states[id].barcode,
							timestamp_start: this.recording_states[id].startedAt instanceof Date
								? this.recording_states[id].startedAt.getTime()
								: new Date(this.recording_states[id].startedAt).getTime(),
							timestamp_end: new Date().getTime(),
							deviceId: device.deviceId,
							rtsp: device.rtsp,
							state: 2 // 2 = finalizado
						}).then(res => {
							this.$EventBus && this.$EventBus.$emit('notifications_modal', {
								type: 'success',
								message: 'Sesión finalizada correctamente.'
							});
						}).catch(err => {
							this.$EventBus && this.$EventBus.$emit('notifications_modal', {
								type: 'error',
								message: 'Error al finalizar la sesión.'
							});
						});
					}
					if (Array.isArray(this.deviceTags[id])) {
						this.deviceTags[id].forEach(tag => {
							if (this.tagCounters[id] && this.tagCounters[id][tag]) {
								this.$delete(this.tagCounters[id], tag);
							}
						});
						this.$set(this.deviceTags, id, []);
					}
					// Limpiar dispositivos vacíos
					Object.keys(this.tagCounters).forEach(deviceId => {
						if (this.tagCounters[deviceId] && Object.keys(this.tagCounters[deviceId]).length === 0) {
							this.$delete(this.tagCounters, deviceId);
						}
					});
					localStorage.setItem('parking_tag_counters', JSON.stringify(this.tagCounters));
					this.endDevice(device);
					this.$set(this.finishingLock, id, false); // Desbloquear al final
				}, 2000);
				// --- Fin de la animación diferida ---
			} else {
				// --- ANIMACIÓN DE INICIO ---
				this.$set(this.startingAnimation, id, true);
				setTimeout(() => {
					this.$set(this.startingAnimation, id, false);
				}, 2000);
				// Iniciar grabación y guardar fecha/hora y barcode
				const barcode = `BC${Date.now()}${Math.floor(Math.random()*1000)}`;
				const startedAt = new Date();
				const wasVisible = this.isCamVisible(id);
				this.$set(this.recording_states, id, {
					startedAt,
					endedAt: null,
					barcode,
					wasVisible // Guardar si estaba visible antes
				});

				// Emitir evento para notificar que se inició la grabación
				this.$EventBus.$emit('parking_recording_state_changed', {
					deviceId: id,
					recordingState: this.recording_states[id],
					action: 'start'
				});

				// Reiniciar contadores de tags para este device
				this.$set(this.tagCounters, id, {});
				this.$set(this.deviceTags, id, []);

				// Enviar request al backend para iniciar conteo
				this.$axios.post(api, {
					barcode: barcode,
					timestamp_start: startedAt.getTime(), // UTC en milisegundos
					deviceId: device.deviceId,
					rtsp: device.rtsp,
					state: 1 // 1 = sesión de conteo activa
				}).then(res => {
					
					
					// Guardar el id de la sesión retornado por el backend
					const sessionId = res.data?.data?.id;
					if (sessionId) {
						
						this.$set(this.recording_states[id], 'id', sessionId);
						
					} else {
						//console.warn('⚠️ [DEBUG] No se encontró id en la respuesta del backend');
						//console.warn('⚠️ [DEBUG] Estructura completa de res.data:', JSON.stringify(res.data, null, 2));
					}
					this.$EventBus && this.$EventBus.$emit('notifications_modal', {
						type: 'success',
						message: 'Sesión iniciada correctamente.'
					});
				}).catch(err => {
					//console.error('❌ [DEBUG] Error al iniciar sesión:', err);
					this.$EventBus && this.$EventBus.$emit('notifications_modal', {
						type: 'error',
						message: 'Error al iniciar la sesión.'
					});
				});

				// Si la cámara está oculta, mostrar animación de conteo en lugar de mostrar la cámara
				if (!wasVisible) {
					this.showCountingAnimation(id);
				}
				this.startDevice(device);
			}
		},
		getRecordingStart(deviceId) {
			const state = this.recording_states[deviceId];
			if (state && state.startedAt) {
				try {
					let date;
					if (state.startedAt instanceof Date) {
						date = state.startedAt;
					} else if (typeof state.startedAt === 'number') {
						date = new Date(state.startedAt);
					} else if (typeof state.startedAt === 'string') {
						const parsed = parseInt(state.startedAt);
						if (!isNaN(parsed)) {
							date = new Date(parsed);
						} else {
							date = new Date(state.startedAt);
						}
					} else {
						console.warn('🔍 [DATE-DEBUG] Formato de startedAt no reconocido:', state.startedAt, typeof state.startedAt);
						return 'Fecha inválida';
					}
					
					if (isNaN(date.getTime())) {
						console.warn('🔍 [DATE-DEBUG] Fecha inválida para deviceId:', deviceId, 'startedAt:', state.startedAt);
						return 'Fecha inválida';
					}
					
					return date.toLocaleString();
				} catch (error) {
					console.error('🔍 [DATE-DEBUG] Error procesando fecha:', error, 'startedAt:', state.startedAt);
					return 'Error en fecha';
				}
			}
			return null;
		},
		getRecordingEnd(deviceId) {
			const state = this.recording_states[deviceId];
			if (state && state.endedAt) {
				try {
					let date;
					if (state.endedAt instanceof Date) {
						date = state.endedAt;
					} else if (typeof state.endedAt === 'number') {
						date = new Date(state.endedAt);
					} else if (typeof state.endedAt === 'string') {
						const parsed = parseInt(state.endedAt);
						if (!isNaN(parsed)) {
							date = new Date(parsed);
						} else {
							date = new Date(state.endedAt);
						}
					} else {
						console.warn('🔍 [DATE-DEBUG] Formato de endedAt no reconocido:', state.endedAt, typeof state.endedAt);
						return 'Fecha inválida';
					}
					
					if (isNaN(date.getTime())) {
						console.warn('🔍 [DATE-DEBUG] Fecha inválida para deviceId:', deviceId, 'endedAt:', state.endedAt);
						return 'Fecha inválida';
					}
					
					return date.toLocaleString();
				} catch (error) {
					console.error('🔍 [DATE-DEBUG] Error procesando fecha de fin:', error, 'endedAt:', state.endedAt);
					return 'Error en fecha';
				}
			}
			return null;
		},
		getRecordingDuration(deviceId) {
			const state = this.recording_states[deviceId];
			if (state && state.startedAt) {
				try {
					// Convertir startedAt de manera robusta
					let start;
					if (state.startedAt instanceof Date) {
						start = state.startedAt;
					} else if (typeof state.startedAt === 'number') {
						start = new Date(state.startedAt);
					} else if (typeof state.startedAt === 'string') {
						const parsed = parseInt(state.startedAt);
						if (!isNaN(parsed)) {
							start = new Date(parsed);
						} else {
							start = new Date(state.startedAt);
						}
					} else {
						console.warn('🔍 [DURATION-DEBUG] Formato de startedAt no reconocido:', state.startedAt);
						return 'Error en duración';
					}
					
					// Convertir endedAt de manera robusta
					let end;
					if (state.endedAt) {
						if (state.endedAt instanceof Date) {
							end = state.endedAt;
						} else if (typeof state.endedAt === 'number') {
							end = new Date(state.endedAt);
						} else if (typeof state.endedAt === 'string') {
							const parsed = parseInt(state.endedAt);
							if (!isNaN(parsed)) {
								end = new Date(parsed);
							} else {
								end = new Date(state.endedAt);
							}
						} else {
							end = new Date();
						}
					} else {
						end = new Date(); // Si no hay fecha de fin, usar la actual
					}
					
					// Verificar que las fechas sean válidas
					if (isNaN(start.getTime())) {
						console.warn('🔍 [DURATION-DEBUG] Fecha de inicio inválida:', state.startedAt);
						return 'Error en duración';
					}
					if (isNaN(end.getTime())) {
						console.warn('🔍 [DURATION-DEBUG] Fecha de fin inválida:', state.endedAt);
						return 'Error en duración';
					}
					
					let diff = Math.max(0, end - start);
					// Formatear duración hh:mm:ss
					let sec = Math.floor(diff / 1000);
					let h = Math.floor(sec / 3600);
					let m = Math.floor((sec % 3600) / 60);
					let s = sec % 60;
					return `${h.toString().padStart(2,'0')}:${m.toString().padStart(2,'0')}:${s.toString().padStart(2,'0')}`;
				} catch (error) {
					console.error('🔍 [DURATION-DEBUG] Error calculando duración:', error);
					return 'Error en duración';
				}
			}
			return null;
		},
		openEditDialog(deviceId, type) {
			this.editDialog.deviceId = deviceId;
			this.editDialog.type = type;
			this.editDialog.visible = true;
			const state = this.recording_states[deviceId];
			if (type === 'start' && state && state.startedAt) {
				this.editDialog.value = this.formatForInput(state.startedAt);
			} else if (type === 'end' && state && state.endedAt) {
				this.editDialog.value = this.formatForInput(state.endedAt);
			} else {
				this.editDialog.value = '';
			}
		},
		async saveEditTime() {
			const { deviceId, type, value } = this.editDialog;
			if (!deviceId || !type || !value) return;
			// value es formato 'YYYY-MM-DDTHH:mm'
			const date = new Date(value);
			let state = this.recording_states[deviceId];
			if (!state) return;

			// Debug: ver el estado actual
			console.log('🔍 [DEBUG-EDIT] Intentando editar fecha para deviceId:', deviceId);
			console.log('🔍 [DEBUG-EDIT] Estado actual:', state);
			console.log('🔍 [DEBUG-EDIT] state.id:', state.id);
			console.log('🔍 [DEBUG-EDIT] state.barcode:', state.barcode);

			// Verificar que existe el id de la sesión
			if (!state.id) {
				console.warn('⚠️ [DEBUG-EDIT] No se encontró id de sesión para editar');
				this.$EventBus && this.$EventBus.$emit('notifications_modal', {
					type: 'error',
					message: 'No se encontró el ID de la sesión para editar.'
				});
				this.editDialog.visible = false;
				return;
			}

			// Actualizar localmente
			if (type === 'start') {
				this.$set(this.recording_states[deviceId], 'startedAt', date);
			} else if (type === 'end') {
				this.$set(this.recording_states[deviceId], 'endedAt', date);
			}

			// Preparar datos para el backend
			const updateData = {
				barcode: state.barcode,
				deviceId: deviceId,
				state: state.endedAt ? 2 : 1 // 1 = en progreso, 2 = finalizado
			};
			if (type === 'start' && state.startedAt) {
				updateData.timestamp_start = new Date(state.startedAt).getTime();
			}
			if (type === 'end' && state.endedAt) {
				updateData.timestamp_end = new Date(state.endedAt).getTime();
			}

			try {
				const api = this.$URL + '/api/v1/operationsession/' + state.id;
				console.log('🔍 [DEBUG-EDIT] URL del PUT:', api);
				console.log('🔍 [DEBUG-EDIT] Datos a enviar:', updateData);
				const response = await this.$axios.put(api, updateData);
				if (response && response.status === 200) {
					this.$EventBus && this.$EventBus.$emit('notifications_modal', {
						type: 'success',
						message: `Fecha de ${type === 'start' ? 'inicio' : 'fin'} actualizada correctamente`
					});
					
					// Emitir evento para actualizar la tabla de eventos counter
					this.$EventBus.$emit('parking_date_updated', {
						deviceId: deviceId,
						barcode: state.barcode,
						type: type, // 'start' o 'end'
						value: date,
						recordingState: this.recording_states[deviceId]
					});
					
				} else {
					throw new Error('Respuesta inesperada del servidor');
				}
			} catch (error) {
				console.error(`❌ [PARKING-SAVE] Error guardando ${type}:`, error);
				this.$EventBus && this.$EventBus.$emit('notifications_modal', {
					type: 'error',
					message: `Error al actualizar fecha de ${type === 'start' ? 'inicio' : 'fin'}`
				});
			}

			this.editDialog.visible = false;
		},
		formatForInput(date) {
			if (!date) return '';
			const d = new Date(date);
			// Formato 'YYYY-MM-DDTHH:mm' para datetime-local
			const pad = n => n.toString().padStart(2, '0');
			return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
		},
		isCamVisible(deviceId) {
			// Priorizar el store sobre el estado local
			const storeVis = this.$store.getters['Dashboard/camVisibility'];
			
			if (storeVis && typeof storeVis[deviceId] !== 'undefined') {
				return storeVis[deviceId];
			}
			
			// Si no hay en el store, usar el estado local
			if (typeof this.camVisibility[deviceId] !== 'undefined') {
				return this.camVisibility[deviceId];
			}
			
			// Por defecto, mostrar la cámara
			return true;
		},
		toggleCam(deviceId) {
			const newVal = !this.isCamVisible(deviceId);
			this.$set(this.camVisibility, deviceId, newVal);
			// Guardar en el store para persistencia
			this.$store.dispatch('Dashboard/setCamVisibility', { deviceId, value: newVal });
		},
		toggleAllCams() {
			const newVal = !this.allCamsVisible;
			// Construir el nuevo objeto de visibilidad
			const newCamVisibility = {};
			this.devices.forEach(d => {
				newCamVisibility[d.deviceId] = newVal;
			});
			// Actualizar el store de una sola vez
			this.$store.dispatch('Dashboard/setCamVisibilityAll', newCamVisibility);
			// Sincronizar el estado local después de un tick
			this.$nextTick(() => {
				Object.entries(newCamVisibility).forEach(([deviceId, value]) => {
					this.$set(this.camVisibility, deviceId, value);
				});
			});
		},
		// NUEVO: Métodos para el selector de cámaras
		toggleCameraSelection(deviceId) {
			const index = this.selectedCameras.indexOf(deviceId);
			if (index > -1) {
				// Remover de la selección
				this.selectedCameras.splice(index, 1);
			} else {
				// Agregar a la selección
				this.selectedCameras.push(deviceId);
			}
			// Guardar en localStorage
			localStorage.setItem('parking_selected_cameras', JSON.stringify(this.selectedCameras));
		},
		selectAllCameras() {
			this.selectedCameras = this.devices.map(device => device.deviceId);
			localStorage.setItem('parking_selected_cameras', JSON.stringify(this.selectedCameras));
		},
		deselectAllCameras() {
			this.selectedCameras = [];
			localStorage.setItem('parking_selected_cameras', JSON.stringify(this.selectedCameras));
		},
		// Sincroniza camVisibility local con el store antes de guardar
		syncCamVisibilityWithStore() {
			try {
				// Convertir camVisibility local a objeto plano - extraer valores reales
				// Usar JSON.parse(JSON.stringify()) para obtener valores planos del objeto reactivo
				const plainCamVisibility = JSON.parse(JSON.stringify(this.camVisibility));
				
				// Usar la nueva acción para actualizar todo el objeto de una vez
				this.$store.dispatch('Dashboard/setCamVisibilityAll', plainCamVisibility);
				
				// Emite evento para notificar que se sincronizó
				this.$emit('camVisibilitySynced', plainCamVisibility);
			} catch (error) {
				console.error('❌ ERROR en syncCamVisibilityWithStore:', error);
			}
		},
		// Método público para sincronizar desde componentes externos
		syncCamVisibility() {
			this.syncCamVisibilityWithStore();
		},
		// Método para verificar si una cámara estaba visible antes de iniciar el conteo
		wasVisibleBeforeRecording(deviceId) {
			// Si no hay estado de grabación, no estaba visible antes
			if (!this.recording_states[deviceId]) {
				return false;
			}
			// Si hay estado de grabación pero no tiene la propiedad wasVisible, asumir que estaba visible
			return this.recording_states[deviceId].wasVisible !== false;
		},
		// Método para mostrar animación de conteo en cámaras ocultas
		showCountingAnimation(deviceId, objectData = null) {
			// Activar la animación
			this.$set(this.countingAnimation, deviceId, true);
			
			// Guardar información del objeto detectado si se proporciona
			if (objectData) {
				this.$set(this.detectedObjects, deviceId, {
					type: objectData.objectType || 'Objeto',
					confidence: objectData.confidence || null,
					timestamp: objectData.timestamp || new Date(),
					...objectData
				});
			}
			
			// Desactivar la animación después de 2 segundos
			setTimeout(() => {
				this.$set(this.countingAnimation, deviceId, false);
				// Limpiar información del objeto después de la animación
				this.$delete(this.detectedObjects, deviceId);
			}, 2000);
		},
		// Método para verificar si una cámara está mostrando la animación de conteo
		isShowingCountingAnimation(deviceId) {
			return !!this.countingAnimation[deviceId];
		},
		// Cambia el texto de la animación según el estado
		getDetectedObjectText(deviceId) {
			if (this.finishingAnimation[deviceId]) {
				return 'Finalizando conteo...';
			}
			if (this.startingAnimation[deviceId]) {
				return 'Iniciando conteo...';
			}
			const objectData = this.detectedObjects[deviceId];
			if (objectData && objectData.type) {
				return `¡${objectData.type} detectado!`;
			}
			// Si no hay eventos y está grabando, mostrar iniciando conteo
			if (this.isRecording(deviceId)) {
				return 'Iniciando conteo...';
			}
			return '¡Objeto detectado!';
		},
		// Método para obtener detalles del objeto detectado
		getDetectedObjectDetails(deviceId) {
			const objectData = this.detectedObjects[deviceId];
			if (objectData) {
				let details = 'Conteo registrado';
				if (objectData.confidence) {
					details += ` (${Math.round(objectData.confidence * 100)}% confianza)`;
				}
				return details;
			}
			return 'Conteo registrado';
		},
		// Método para manejar detección de objetos desde EventBus
		handleObjectDetection(data) {
			// data debe contener al menos: { deviceId }
			const deviceId = data.deviceId;
			if (this.devices.some(d => d.deviceId === deviceId)) {
				// Si la cámara está oculta, mostrar animación de conteo con datos del objeto
				if (!this.isCamVisible(deviceId)) {
					this.showCountingAnimation(deviceId, data);
				}
				// ...opcional: actualizar contadores, emitir eventos, etc...
			}
		},
		
		// NUEVO: Método para manejar eventos de counter desde connections.vue
		handleCounterEvent(data) {
			// Validar que data existe y tiene las propiedades necesarias
			if (!data || typeof data !== 'object') {
				console.warn('⚠️ [PARKING-COUNTER-EVENT] Datos inválidos recibidos:', data);
				return;
			}
			console.log('data', data);
			// Verificar si es un evento de operación de sesión
			if (data.action && (data.action === 'session_started' || data.action === 'session_ended')) {
				// Procesar según el tipo de acción
				if (data.action === 'session_started') {
					//console.log('🟢 [PARKING] Procesando inicio de sesión...');
					this.handleSessionStartNotification(data);
				} else if (data.action === 'session_ended') {
					//console.log('🔴 [PARKING] Procesando finalización de sesión...');
					this.handleSessionEndNotification(data);
				}
			} else {
				// NUEVO: Procesar eventos de counter basándose en el state
				if (data.barcode && data.deviceId) {
					// Verificar si es un evento de sesión activa (state = 1)
					if (data.state === 1) {
						//console.log('🟢 [PARKING] Sesión activa detectada (state=1)');
						
						// Crear estructura de datos compatible con handleSessionStartNotification
						const sessionData = {
							id: data.id,
							barcode: data.barcode,
							deviceId: data.deviceId,
							timestamp_start: data.timestamp_start,
							timestamp_end: data.timestamp_end,
							state: data.state,
							totalizer: data.totalizer || []
						};
						
						const eventData = {
							action: 'session_started',
							message: `Sesión iniciada para barcode: ${data.barcode}`,
							sessionData: sessionData,
							deviceId: data.deviceId,
							timestamp: new Date().toISOString()
						};
						
						this.handleSessionStartNotification(eventData);
						
					} else if (data.state === 2) {
						//console.log('🔴 [PARKING] Finalización de sesión detectada (state=2)');
						
						// Crear estructura de datos compatible con handleSessionEndNotification
						const sessionData = {
							id: data.id,
							barcode: data.barcode,
							deviceId: data.deviceId,
							timestamp_start: data.timestamp_start,
							timestamp_end: data.timestamp_end,
							state: data.state,
							totalizer: data.totalizer || []
						};
						
						const eventData = {
							action: 'session_ended',
							message: `Sesión finalizada para barcode: ${data.barcode}`,
							sessionData: sessionData,
							deviceId: data.deviceId,
							timestamp: new Date().toISOString()
						};
						
						this.handleSessionEndNotification(eventData);
						
					} else {
						//console.log('🟢 [PARKING] Estado no reconocido:', data.state);
					}
				} else {
					//console.log('🟢 [PARKING] Datos incompletos - faltan barcode o deviceId');
				}
			}
		},
		// Método para manejar eventos smart_event desde EventBus
		handleSmartEvent(data) {
			console.log('[SmartEvent] Recibido:', data);

			const deviceId = data.deviceId || (data.device && data.device.deviceId);
			if (!deviceId) {
				console.log('[SmartEvent] No deviceId encontrado en:', data);
				return;
			}

			// Solo contar si la cámara está grabando
			if (!this.isRecording(deviceId)) {
				console.log('[SmartEvent] Dispositivo', deviceId, 'no está grabando, ignorando evento');
				return;
			}

			let direction = 'in';
			if (typeof data.way === 'string') {
				direction = data.way.trim().toLowerCase() === 'out' ? 'out' : 'in';
			} else if (typeof data.side === 'number') {
				direction = data.side === 1 ? 'out' : 'in';
			}

			let tags = [];
			// Buscar tags en diferentes ubicaciones posibles según el formato del evento
			if (data.formated && data.formated.content && data.formated.content.tag) {
				if (Array.isArray(data.formated.content.tag)) {
					tags = data.formated.content.tag;
				} else if (typeof data.formated.content.tag === 'string') {
					tags = data.formated.content.tag.split(',').map(t => t.trim()).filter(Boolean);
				}
			} else if (data.formated && data.formated.tags) {
				// Los tags están en formated.tags según el formato de check_bbox_tags
				if (Array.isArray(data.formated.tags)) {
					tags = data.formated.tags;
				} else if (typeof data.formated.tags === 'string') {
					tags = data.formated.tags.split(',').map(t => t.trim()).filter(Boolean);
				}
			} else if (data.tag) {
				// Tag directo en el objeto
				if (Array.isArray(data.tag)) {
					tags = data.tag;
				} else if (typeof data.tag === 'string') {
					tags = data.tag.split(',').map(t => t.trim()).filter(Boolean);
				}
			}
			
			if (tags.length === 0) {
				console.log('[SmartEvent] No tags encontrados en:', data);
				return;
			}

			console.log('[SmartEvent] Procesando tags:', tags, 'direction:', direction);

			const device = this.devices.find(d => d.deviceId === deviceId);
			if (device) {
				// Asegurar que el dispositivo tenga su propio array de tags
				if (!Array.isArray(this.deviceTags[deviceId])) {
					this.$set(this.deviceTags, deviceId, []);
				}
				
				let countersUpdated = false;
				tags.forEach(tag => {
					if (!tag) return;
					if (!this.tagCounters[deviceId] || !this.tagCounters[deviceId][tag]) {
						this.$set(this.tagCounters, deviceId, { ...this.tagCounters[deviceId], [tag]: { in: 0, out: 0 } });
					}
					if (direction === 'in') {
						this.tagCounters[deviceId][tag].in += 1;
					} else if (direction === 'out') {
						this.tagCounters[deviceId][tag].out += 1;
					}
					// Agregar tag al array del dispositivo si no existe
					if (!this.deviceTags[deviceId].includes(tag)) {
						this.deviceTags[deviceId].push(tag);
					}
					countersUpdated = true;
					console.log('[SmartEvent] tagCounters actualizado:', JSON.parse(JSON.stringify(this.tagCounters)));
					console.log(`[SmartEvent] deviceTags (${deviceId}):`, this.deviceTags[deviceId]);
				});

				// Emitir evento para actualizar la tabla counter si los contadores cambiaron
				if (countersUpdated) {
					const barcode = this.recording_states[deviceId]?.barcode;
					const totalizers = this.deviceTags[deviceId].map(tag => ({
						tag,
						in: this.tagCounters[deviceId] && this.tagCounters[device.deviceId][tag]?.in || 0,
						out: this.tagCounters[deviceId] && this.tagCounters[device.deviceId][tag]?.out || 0
					}));
					this.$EventBus.$emit('parking_counter_updated', {
						barcode,
						totalizers
					});
					console.log('[SmartEvent] Evento parking_counter_updated emitido', { barcode, totalizers });
				}

				// Guardar la última imagen recibida para este device
				if (data.img) {
					this.$set(device, 'lastSmartEventImg', data.img);
				}
                // Guardar el bbox recibido para este device
                if (data.bbox) {
                    this.$set(device, 'lastSmartEventBbox', data.bbox);
                } else if (data.formated && data.formated.content && data.formated.content.bbox) {
                    this.$set(device, 'lastSmartEventBbox', data.formated.content.bbox);
                } else {
                    this.$set(device, 'lastSmartEventBbox', null);
                }

					// --- HISTORIAL DE IMÁGENES Y ANIMACIÓN ---
					if (data.img) {
						if (!this.imageHistory[deviceId]) {
							this.$set(this.imageHistory, deviceId, []);
						}
						const bbox = data.bbox || (data.formated && data.formated.content && data.formated.content.bbox) || null;
						const newEntry = { img: data.img, bbox, direction, id: Date.now() };
						const history = this.imageHistory[deviceId];
						history.push(newEntry);
						if (history.length > 2) history.shift();
						this.$set(this.imageHistory, deviceId, history);
						// Marcar animación activa
						this.$set(this.imageTransition, deviceId, { animating: true, direction });
						setTimeout(() => {
							this.$set(this.imageTransition, deviceId, { animating: false, direction });
						}, 500);
					}
					// --- FIN HISTORIAL ---

					if (!this.isCamVisible(device.deviceId)) {
						this.showCountingAnimation(device.deviceId, data);
					}
				}
			},
		// Método para resetear contadores
		resetCounters() {
			this.tagCounters = {};
		},
		getTagsWithCounter(device) {
			// Devuelve solo los tags con data real (in > 0 o out > 0) para este dispositivo específico
			const deviceTags = Array.isArray(this.deviceTags[device.deviceId]) ? this.deviceTags[device.deviceId] : [];
			const filteredTags = deviceTags.filter(tag => {
				const c = this.tagCounters[device.deviceId] && this.tagCounters[device.deviceId][tag];
				return (c && (c.in > 0 || c.out > 0));
			});
			
			return filteredTags;
		},
		getHiddenCamStyle(device) {
			let style = 'flex:1 1 0; position:relative; aspect-ratio: 1 / 1; min-width: 200px; min-height: 200px; width: 100%; display: flex; align-items: center; justify-content: center; background: #111; border-radius: 4px; overflow: auto; padding: 8px 0;';
			if (device.lastSmartEventImg) {
				style += ` background-image: url('${device.lastSmartEventImg}'); background-size: cover; background-position: center; background-repeat: no-repeat;`;
			}
			return style;
		},
		getSliderImageStyle(img) {
			return `background-image: url('${img}');`;
		},
		getBboxStyle(bbox) {
			// bbox: {x, y, w, h} en proporciones (0-1)
			if (!bbox) return '';
			const left = (parseFloat(bbox.x) * 100) + '%';
			const top = (parseFloat(bbox.y) * 100) + '%';
			const width = (parseFloat(bbox.w) * 100) + '%';
			const height = (parseFloat(bbox.h) * 100) + '%';
			return `left:${left};top:${top};width:${width};height:${height};`;
		},
		getImageSlideClass(device, idx) {
			const t = this.imageTransition[device.deviceId];
			if (!t || !t.animating) return '';
			if (t.direction === 'in') {
				return idx === 0 ? 'slide-out-right' : 'slide-in-left';
			} else if (t.direction === 'out') {
				return idx === 0 ? 'slide-out-left' : 'slide-in-right';
			}
			return '';
		},
		generatePdf(device) {
			const doc = new jsPDF();
			const state = this.recording_states[device.deviceId];
			const tags = Array.isArray(this.deviceTags[device.deviceId]) ? this.deviceTags[device.deviceId] : [];
			const tagRows = tags.map(tag => [tag.toUpperCase(), this.tagCounters[device.deviceId] && this.tagCounters[device.deviceId][tag]?.in || 0, this.tagCounters[device.deviceId] && this.tagCounters[device.deviceId][tag]?.out || 0]);
			const start = state && state.startedAt ? new Date(state.startedAt).toLocaleString() : '';
			const end = state && state.endedAt ? new Date(state.endedAt).toLocaleString() : '';
			const duration = (() => {
				if (state && state.startedAt) {
					let endD = state.endedAt ? new Date(state.endedAt) : new Date();
					let startD = new Date(state.startedAt);
					let diff = Math.max(0, endD - startD);
					let sec = Math.floor(diff / 1000);
					let h = Math.floor(sec / 3600);
					let m = Math.floor((sec % 3600) / 60);
					let s = sec % 60;
					return `${h.toString().padStart(2,'0')}:${m.toString().padStart(2,'0')}:${s.toString().padStart(2,'0')}`;
				}
				return '';
			})();
			doc.setFontSize(16);
			doc.text(`Reporte de Conteo - ${device.name || ''}`, 14, 18);
			doc.setFontSize(12);
			doc.text(`Barcode: ${state?.barcode || ''}`, 14, 28);
			doc.text(`Inicio: ${start}`, 14, 36);
			doc.text(`Fin: ${end}`, 14, 44);
			doc.text(`Duración: ${duration}`, 14, 52);
			doc.autoTable({
				startY: 60,
				head: [['TAG', 'IN', 'OUT']],
				body: tagRows,
				styles: {
					halign: 'center',
					fillColor: [255, 255, 255], // fondo blanco
					textColor: [0, 0, 0],       // texto negro
					lineColor: [0, 0, 0],       // bordes negros
					lineWidth: 0.1
				},
				headStyles: {
					fillColor: [255, 255, 255], // fondo blanco para encabezado
					textColor: [0, 0, 0],       // texto negro para encabezado
					fontStyle: 'bold',
					lineColor: [0, 0, 0],       // bordes negros
					lineWidth: 0.1
				},
				alternateRowStyles: {
					fillColor: [255, 255, 255], // filas alternas también blancas
					textColor: [0, 0, 0]
				},
				tableLineColor: [0, 0, 0],   // bordes de la tabla negros
				tableLineWidth: 0.1
			});
			doc.save(`conteo_${device.name || ''}_${state?.barcode || ''}.pdf`);
		},
		// Método para manejar actualizaciones de contadores desde event.js
		handleCounterUpdate(data) {
			const { deviceId, tag, count } = data;
			console.log(`📊 [PARKING-UPDATE] Actualizando contador para dispositivo ${deviceId}, tag ${tag}: ${count}`);
			
			// Verificar que el dispositivo esté grabando
			if (!this.isRecording(deviceId)) {
				console.log(`📊 [PARKING-UPDATE] Dispositivo ${deviceId} no está grabando, ignorando actualización`);
				return;
			}
			
			// Actualizar el contador local
			if (!this.tagCounters[deviceId] || !this.tagCounters[deviceId][tag]) {
				this.$set(this.tagCounters, deviceId, { ...this.tagCounters[deviceId], [tag]: { in: 0, out: 0 } });
			}
			
			// Solo actualizar si el contador del backend es mayor (para evitar retroceder)
			if (count > this.tagCounters[deviceId][tag].in) {
				this.tagCounters[deviceId][tag].in = count;
				console.log(`📊 [PARKING-UPDATE] Contador actualizado: ${tag} = ${count}`);
			}
		},

		// Método para emitir actualización inicial de todos los contadores
		emitInitialCounterUpdate() {
			this.devices.forEach(device => {
				if (this.isRecording(device.deviceId)) {
					const deviceTags = Array.isArray(this.deviceTags[device.deviceId]) ? this.deviceTags[device.deviceId] : [];
					if (deviceTags.length > 0) {
						// Filtrar solo los contadores que tienen valores > 0
						const activeTagCounters = {};
						deviceTags.forEach(tag => {
							if (this.tagCounters[device.deviceId] && this.tagCounters[device.deviceId][tag] && (this.tagCounters[device.deviceId][tag].in > 0 || this.tagCounters[device.deviceId][tag].out > 0)) {
								activeTagCounters[tag] = { ...this.tagCounters[device.deviceId][tag] };
							}
						});
						
						// Emitir incluso si no hay contadores activos para crear la entrada
						this.$EventBus.$emit('parking_counter_updated', {
							deviceId: device.deviceId,
							tagCounters: activeTagCounters,
							recordingState: this.recording_states[device.deviceId]
						});
					}
				}
			});
		},
		getDeviceName(deviceId) {
			const device = this.devices.find(d => d.deviceId === deviceId);
			return device ? device.name : deviceId;
		},

		// Método para validar todos los contadores activos al cargar el componente
		async validateAllActiveCountersOnLoad() {
			//console.log('🔄 [F5-VALIDATION] Iniciando validación automática de contadores después de recarga...');
			
			try {
				// Consultar sesiones activas del backend
				const apiSessions = this.$URL + '/api/v1/operationsession/?page=1';
				//console.log('📡 [F5-VALIDATION] Consultando sesiones activas en:', apiSessions);
				
				const response = await this.$axios.get(apiSessions);
				//console.log('📡 [F5-VALIDATION] Respuesta del backend:', response.data);
				
				if (!response.data || !Array.isArray(response.data.rows)) {
					//console.log('⚠️ [F5-VALIDATION] Respuesta del backend no válida');
					return;
				}
				
				// Filtrar solo sesiones activas (state = 1)
				const activeSessions = response.data.rows.filter(session => 
					session.state === 1 && session.barcode && session.deviceId
				);
				
				//console.log(`🔍 [F5-VALIDATION] Sesiones activas encontradas en backend: ${activeSessions.length}`);
				//console.log('🔍 [F5-VALIDATION] Sesiones activas:', activeSessions.map(s => ({
				//	barcode: s.barcode,
				//	deviceId: s.deviceId,
				//	state: s.state,
				//	timestamp_start: s.timestamp_start,
				//	totalizer: s.totalizer
				//})));
				
				if (activeSessions.length === 0) {
					//console.log('ℹ️ [F5-VALIDATION] No hay sesiones activas en el backend (state=1), saltando validación');
					//console.log('ℹ️ [F5-VALIDATION] Limpiando estados locales obsoletos...');
					
					// Limpiar estados locales si no hay sesiones activas en el backend
					this.recording_states = {};
					this.tagCounters = {};
					this.deviceTags = {};
					localStorage.setItem('parking_recording_states', JSON.stringify({}));
					localStorage.setItem('parking_tag_counters', JSON.stringify({}));
					localStorage.setItem('parking_device_tags', JSON.stringify({}));
					
					return;
				}
				
				// Sincronizar estados locales con las sesiones activas del backend
				const updatedRecordingStates = {};
				const updatedTagCounters = {};
				const updatedDeviceTags = {};
				let syncedDevices = [];
				
				for (const session of activeSessions) {
					const device = this.devices.find(d => d.deviceId === session.deviceId);
					if (!device) {
						//console.log(`⚠️ [F5-VALIDATION] Dispositivo ${session.deviceId} no encontrado en lista local`);
						continue;
					}
					
					//console.log(`🔍 [F5-VALIDATION] Procesando sesión activa para ${device.name}:`, session);
					//console.log(`🔍 [F5-DEBUG] timestamp_start original:`, session.timestamp_start, typeof session.timestamp_start);
					
					// Convertir timestamp correctamente
					let startedAt;
					if (typeof session.timestamp_start === 'number') {
						startedAt = new Date(session.timestamp_start);
					} else if (typeof session.timestamp_start === 'string') {
						// Si es string, puede ser timestamp en string o fecha ISO
						const parsed = parseInt(session.timestamp_start);
						if (!isNaN(parsed)) {
							startedAt = new Date(parsed);
						} else {
							startedAt = new Date(session.timestamp_start);
						}
					} else {
						startedAt = new Date();
					}
					
					//console.log(`🔍 [F5-DEBUG] startedAt convertido:`, startedAt, startedAt.toLocaleString());
					
					// Restaurar/actualizar estado local
					updatedRecordingStates[session.deviceId] = {
						id: session.id,
						barcode: session.barcode,
						startedAt: startedAt,
						endedAt: null, // state=1 significa activa
						wasVisible: this.recording_states[session.deviceId]?.wasVisible ?? true
					};
					
					// Procesar totalizer del backend
					if (Array.isArray(session.totalizer) && session.totalizer.length > 0) {
						//console.log(`📊 [F5-VALIDATION] Procesando totalizer para ${device.name}:`, session.totalizer);
						
						// Inicializar contadores para este dispositivo
						updatedTagCounters[session.deviceId] = {};
						updatedDeviceTags[session.deviceId] = [];
						
						// Procesar cada tag del totalizer
						session.totalizer.forEach(item => {
							if (item.tag) {
								// Actualizar contadores
								updatedTagCounters[session.deviceId][item.tag] = {
									in: parseInt(item.in) || 0,
									out: parseInt(item.out) || 0
								};
								
								// Agregar tag a la lista de dispositivo
								if (!updatedDeviceTags[session.deviceId].includes(item.tag)) {
									updatedDeviceTags[session.deviceId].push(item.tag);
								}
								
								//console.log(`✅ [F5-VALIDATION] Tag sincronizado: ${item.tag} - IN: ${item.in}, OUT: ${item.out}`);
							}
						});
						
						// Comparar con contadores locales si existen
						const localCounters = this.tagCounters[session.deviceId];
						if (localCounters) {
							session.totalizer.forEach(item => {
								const localIn = localCounters[item.tag]?.in || 0;
								const localOut = localCounters[item.tag]?.out || 0;
								const backendIn = parseInt(item.in) || 0;
								const backendOut = parseInt(item.out) || 0;
								
								if (localIn !== backendIn || localOut !== backendOut) {
									//console.log(`⚠️ [F5-VALIDATION] Diferencia en ${item.tag} para ${device.name}:`);
									//console.log(`   Local: IN=${localIn}, OUT=${localOut}`);
									//console.log(`   Backend: IN=${backendIn}, OUT=${backendOut}`);
								}
							});
						}
						
						syncedDevices.push(device.name);
						
						// Emitir evento de actualización inmediatamente
						const totalizers = session.totalizer.map(item => ({
							tag: item.tag,
							in: parseInt(item.in) || 0,
							out: parseInt(item.out) || 0
						}));
						
						this.$EventBus.$emit('parking_counter_updated', {
							barcode: session.barcode,
							totalizers,
							deviceId: session.deviceId,
							recordingState: updatedRecordingStates[session.deviceId]
						});
						
						//console.log(`📊 [F5-VALIDATION] Evento parking_counter_updated emitido para ${device.name}`, { totalizers });
						
					} else {
						//console.log(`ℹ️ [F5-VALIDATION] No hay totalizer para ${device.name}, limpiando contadores locales`);
						// Si no hay totalizer en el backend, limpiar contadores locales para este dispositivo
						updatedTagCounters[session.deviceId] = {};
						updatedDeviceTags[session.deviceId] = [];
						
						syncedDevices.push(device.name);
						
						// Emitir evento de actualización con contadores vacíos
						this.$EventBus.$emit('parking_counter_updated', {
							barcode: session.barcode,
							totalizers: [],
							deviceId: session.deviceId,
							recordingState: updatedRecordingStates[session.deviceId]
						});
					}
				}
				
				// Actualizar estados locales
				this.recording_states = updatedRecordingStates;
				this.tagCounters = updatedTagCounters;
				this.deviceTags = updatedDeviceTags;
				
				// Guardar en localStorage
				localStorage.setItem('parking_recording_states', JSON.stringify(this.recording_states));
				localStorage.setItem('parking_tag_counters', JSON.stringify(this.tagCounters));
				localStorage.setItem('parking_device_tags', JSON.stringify(this.deviceTags));
				
				//console.log(`✅ [F5-VALIDATION] Estados sincronizados completamente:`);
				//console.log(`   - Dispositivos activos: ${Object.keys(updatedRecordingStates).length}`);
				//console.log(`   - Dispositivos con contadores: ${Object.keys(updatedTagCounters).length}`);
				//console.log(`   - Dispositivos sincronizados: ${syncedDevices.join(', ')}`);
				
				// Notificación de éxito
				if (syncedDevices.length > 0) {
					this.$EventBus && this.$EventBus.$emit('notifications_modal', {
						type: 'success',
						message: `Contadores sincronizados exitosamente para: ${syncedDevices.join(', ')}`
					});
				}
				
				//console.log('✅ [F5-VALIDATION] Validación automática completada');
				
			} catch (error) {
				//console.error('❌ [F5-VALIDATION] Error consultando sesiones activas:', error);
				this.$EventBus && this.$EventBus.$emit('notifications_modal', {
					type: 'error',
					message: 'Error al verificar sesiones activas con el backend'
				});
			}
		},

		// Método para validar contadores por barcode usando el nuevo endpoint
		async validateCountersByBarcode(barcode, deviceId = null) {
			console.log(`🔍 [BARCODE-VALIDATION] Validando contadores para barcode: ${barcode}`);
			
			try {
				const apiBarcode = this.$URL + `/api/v1/operationsession/barcode/${barcode}`;
				//console.log('📡 [BARCODE-VALIDATION] Consultando:', apiBarcode);
				
				const response = await this.$axios.get(apiBarcode);
				//console.log('📡 [BARCODE-VALIDATION] Respuesta del backend:', response.data);
				
				if (!response.data.success || !Array.isArray(response.data.data) || response.data.data.length === 0) {
					//console.log('⚠️ [BARCODE-VALIDATION] No se encontraron sesiones para el barcode:', barcode);
					this.$EventBus && this.$EventBus.$emit('notifications_modal', {
						type: 'warning',
						message: `No se encontraron sesiones para el barcode: ${barcode}`
					});
					return { success: false, message: 'No se encontraron sesiones' };
				}
				
				const sessions = response.data.data;
				//console.log(`✅ [BARCODE-VALIDATION] Encontradas ${sessions.length} sesión(es) para barcode ${barcode}`);
				
				let updatedDevices = [];
				let validationResults = [];
				
				for (const session of sessions) {
					const device = this.devices.find(d => d.deviceId === session.deviceId);
					if (!device) {
						//console.log(`⚠️ [BARCODE-VALIDATION] Dispositivo ${session.deviceId} no encontrado en lista local`);
						continue;
					}
					
					// Si se especifica deviceId, validar solo ese dispositivo
					if (deviceId && session.deviceId !== deviceId) {
						continue;
					}
					
					//console.log(`🔍 [BARCODE-VALIDATION] Validando sesión para ${device.name}:`, session);
					
					// Comparar contadores locales con los del backend
					const localCounters = this.tagCounters[session.deviceId] || {};
					const backendTotalizer = session.totalizer || [];
					let mismatches = [];
					let allMatch = true;
					
					// Verificar contadores del backend vs locales
					backendTotalizer.forEach(backendItem => {
						const tag = backendItem.tag;
						const backendIn = parseInt(backendItem.in) || 0;
						const backendOut = parseInt(backendItem.out) || 0;
						const localIn = localCounters[tag]?.in || 0;
						const localOut = localCounters[tag]?.out || 0;
						
						if (localIn !== backendIn || localOut !== backendOut) {
							allMatch = false;
							mismatches.push({
								tag,
								local: { in: localIn, out: localOut },
								backend: { in: backendIn, out: backendOut }
							});
							//console.log(`⚠️ [BARCODE-VALIDATION] Diferencia en ${tag}:`);
							//console.log(`   Local: IN=${localIn}, OUT=${localOut}`);
							//console.log(`   Backend: IN=${backendIn}, OUT=${backendOut}`);
						}
					});
					
					// Verificar tags locales que no están en el backend
					Object.keys(localCounters).forEach(tag => {
						const backendItem = backendTotalizer.find(item => item.tag === tag);
						if (!backendItem) {
							const localIn = localCounters[tag]?.in || 0;
							const localOut = localCounters[tag]?.out || 0;
							if (localIn > 0 || localOut > 0) {
								allMatch = false;
								mismatches.push({
									tag,
									local: { in: localIn, out: localOut },
									backend: { in: 0, out: 0 }
								});
								//console.log(`⚠️ [BARCODE-VALIDATION] Tag local ${tag} no existe en backend`);
							}
						}
					});
					
					if (allMatch) {
						//console.log(`✅ [BARCODE-VALIDATION] Contadores sincronizados para ${device.name}`);
					} else {
						//console.log(`⚠️ [BARCODE-VALIDATION] ${mismatches.length} diferencias encontradas para ${device.name}`);
						
						// Actualizar contadores locales con valores del backend
						if (!this.tagCounters[session.deviceId]) {
							this.$set(this.tagCounters, session.deviceId, {});
						}
						if (!this.deviceTags[session.deviceId]) {
							this.$set(this.deviceTags, session.deviceId, []);
						}
						
						backendTotalizer.forEach(item => {
							if (item.tag) {
								this.$set(this.tagCounters[session.deviceId], item.tag, {
									in: parseInt(item.in) || 0,
									out: parseInt(item.out) || 0
								});
								
								if (!this.deviceTags[session.deviceId].includes(item.tag)) {
									this.deviceTags[session.deviceId].push(item.tag);
								}
							}
						});
						
						// Emitir evento de actualización
						const totalizers = backendTotalizer.map(item => ({
							tag: item.tag,
							in: parseInt(item.in) || 0,
							out: parseInt(item.out) || 0
						}));
						
						this.$EventBus.$emit('parking_counter_updated', {
							barcode: session.barcode,
							totalizers,
							deviceId: session.deviceId,
							recordingState: this.recording_states[session.deviceId]
						});
					}
					
					validationResults.push({
						deviceId: session.deviceId,
						deviceName: device.name,
						allMatch,
						mismatches,
						session
					});
					
					updatedDevices.push(device.name);
				}
				
				// Mostrar notificación con resultado
				if (validationResults.length > 0) {
					const hasErrors = validationResults.some(r => !r.allMatch);
					if (hasErrors) {
						const devicesWithErrors = validationResults.filter(r => !r.allMatch).map(r => r.deviceName);
						this.$EventBus && this.$EventBus.$emit('notifications_modal', {
							type: 'warning',
							message: `Contadores actualizados desde backend para: ${devicesWithErrors.join(', ')}`
						});
					} else {
						this.$EventBus && this.$EventBus.$emit('notifications_modal', {
							type: 'success',
							message: `Contadores validados correctamente para: ${updatedDevices.join(', ')}`
						});
					}
				}
				
				//console.log(`✅ [BARCODE-VALIDATION] Validación completada para barcode ${barcode}`);
				return { 
					success: true, 
					message: `Validación completada para ${updatedDevices.length} dispositivo(s)`,
					results: validationResults 
				};
				
			} catch (error) {
				//console.error('❌ [BARCODE-VALIDATION] Error validando por barcode:', error);
				this.$EventBus && this.$EventBus.$emit('notifications_modal', {
					type: 'error',
					message: `Error al validar contadores para barcode: ${barcode}`
				});
				return { success: false, message: 'Error en la validación', error };
			}
		},

		// Método de utilidad para validar la sesión actual de un dispositivo
		async validateCurrentSession(deviceId) {
			const state = this.recording_states[deviceId];
			if (!state || !state.barcode) {
				//console.log(`⚠️ [CURRENT-VALIDATION] No hay sesión activa para deviceId: ${deviceId}`);
				return { success: false, message: 'No hay sesión activa' };
			}
			
			//console.log(`🔍 [CURRENT-VALIDATION] Validando sesión actual para deviceId: ${deviceId}, barcode: ${state.barcode}`);
			return await this.validateCountersByBarcode(state.barcode, deviceId);
		},

		// Configurar listeners de WebSocket para notificaciones de sesiones
		setupWebSocketListeners() {
			//console.log('🔌 [WEBSOCKET] Configurando listeners para notificaciones de sesiones...');
			
			// Verificar si hay conexión WebSocket disponible
			if (!this.$socket) {
				console.warn('⚠️ [WEBSOCKET] No hay conexión WebSocket disponible');
				return;
			}
			
			// Listener para inicio de sesiones
			this.$socket.on('server:operation_session_start', (data) => {
				//console.log('🟢 [WEBSOCKET] Sesión iniciada recibida');
				this.handleSessionStartNotification(data);
			});
			
			// Listener para finalización de sesiones
			this.$socket.on('server:operation_session_end', (data) => {
				//console.log('🔴 [WEBSOCKET] Sesión finalizada recibida');
				this.handleSessionEndNotification(data);
			});
			
			//console.log('✅ [WEBSOCKET] Listeners configurados para notificaciones de sesiones');
		},

		// Manejar notificación de inicio de sesión
		handleSessionStartNotification(data) {
			try {
				const sessionData = data.sessionData;
				const deviceId = sessionData.deviceId;
				
				// Verificar si el dispositivo existe en nuestra lista
				const device = this.devices.find(d => d.deviceId === deviceId);
				if (!device) {
					//console.log(`⚠️ [PARKING] Dispositivo ${deviceId} no encontrado en lista local`);
					return;
				}
				
				// Convertir timestamp de manera robusta
				let startedAt;
				if (typeof sessionData.timestamp_start === 'string') {
					const parsed = parseInt(sessionData.timestamp_start);
					startedAt = new Date(parsed);
				} else {
					startedAt = new Date(sessionData.timestamp_start);
				}
				
				// Actualizar estado local
				const newState = {
					id: sessionData.id,
					barcode: sessionData.barcode,
					startedAt: startedAt,
					endedAt: null,
					wasVisible: this.isCamVisible(deviceId)
				};
				
				this.$set(this.recording_states, deviceId, newState);
				
				// Procesar totalizer si existe
				if (Array.isArray(sessionData.totalizer) && sessionData.totalizer.length > 0) {
					if (!this.tagCounters[deviceId]) {
						this.$set(this.tagCounters, deviceId, {});
					}
					if (!this.deviceTags[deviceId]) {
						this.$set(this.deviceTags, deviceId, []);
					}
					
					sessionData.totalizer.forEach((item, index) => {
						if (item.tag) {
							const inCount = parseInt(item.in) || 0;
							const outCount = parseInt(item.out) || 0;
							
							this.$set(this.tagCounters[deviceId], item.tag, {
								in: inCount,
								out: outCount
							});
							
							if (!this.deviceTags[deviceId].includes(item.tag)) {
								this.deviceTags[deviceId].push(item.tag);
							}
						}
					});
					
					// Emitir evento de actualización
					const totalizers = sessionData.totalizer.map(item => ({
						tag: item.tag,
						in: parseInt(item.in) || 0,
						out: parseInt(item.out) || 0
					}));
					
					this.$EventBus.$emit('parking_counter_updated', {
						barcode: sessionData.barcode,
						totalizers,
						deviceId: deviceId,
						recordingState: this.recording_states[deviceId]
					});
				} else {
					// Si no hay totalizer, limpiar contadores locales para este dispositivo
					this.$set(this.tagCounters, deviceId, {});
					this.$set(this.deviceTags, deviceId, []);
					
					// Emitir evento de actualización con contadores vacíos
					this.$EventBus.$emit('parking_counter_updated', {
						barcode: sessionData.barcode,
						totalizers: [],
						deviceId: deviceId,
						recordingState: this.recording_states[deviceId]
					});
				}
				
				// Mostrar notificación
				const notificationMsg = `Nueva sesión iniciada en ${device.name}: ${sessionData.barcode}`;
				
				this.$EventBus && this.$EventBus.$emit('notifications_modal', {
					type: 'info',
					message: notificationMsg
				});
				
				// Emitir evento para el componente padre
				this.$EventBus.$emit('parking_recording_state_changed', {
					deviceId: deviceId,
					recordingState: this.recording_states[deviceId],
					action: 'start'
				});
				
				//console.log(`✅ [PARKING] Sesión iniciada para ${device.name}`);
				
			} catch (error) {
				//console.error('❌ [PARKING] Error procesando notificación de inicio:', error);
			}
		},

		// Manejar notificación de finalización de sesión
		handleSessionEndNotification(data) {
			try {
				// Validar que data y sessionData existen
				if (!data || !data.sessionData) {
					//console.warn('⚠️ [PARKING] Datos incompletos recibidos:', data);
					return;
				}
				
				const sessionData = data.sessionData;
				const deviceId = sessionData.deviceId;
				
				// Validar que deviceId existe
				if (!deviceId) {
					///console.warn('⚠️ [PARKING] DeviceId no encontrado en sessionData');
					return;
				}
				
				// Verificar si el dispositivo existe en nuestra lista
				const device = this.devices.find(d => d.deviceId === deviceId);
				if (!device) {
					//console.log(`⚠️ [PARKING] Dispositivo ${deviceId} no encontrado en lista local`);
					return;
				}
				
				// Verificar si tenemos esta sesión localmente
				const localState = this.recording_states[deviceId];
				if (!localState || localState.barcode !== sessionData.barcode) {
					//console.log(`⚠️ [PARKING] Sesión ${sessionData.barcode} no encontrada localmente para ${device.name}`);
					return;
				}
				
				// Convertir timestamps
				let endedAt;
				if (typeof sessionData.timestamp_end === 'string') {
					const parsed = parseInt(sessionData.timestamp_end);
					endedAt = new Date(parsed);
				} else {
					endedAt = new Date(sessionData.timestamp_end);
				}
				
				// Calcular duración
				const startTime = localState.startedAt;
				const duration = endedAt - startTime;
				const durationMinutes = Math.round(duration / 1000 / 60);
				
				// Actualizar estado local
				this.$set(this.recording_states[deviceId], 'endedAt', endedAt);
				
				// Procesar totalizer final
				if (Array.isArray(sessionData.totalizer) && sessionData.totalizer.length > 0) {
					let totalEvents = 0;
					sessionData.totalizer.forEach((item, index) => {
						if (item.tag && this.tagCounters[deviceId]) {
							const inCount = parseInt(item.in) || 0;
							const outCount = parseInt(item.out) || 0;
							const subtotal = inCount + outCount;
							totalEvents += subtotal;
							
							this.$set(this.tagCounters[deviceId], item.tag, {
								in: inCount,
								out: outCount
							});
						}
					});
					
					// Emitir evento de actualización final
					const totalizers = sessionData.totalizer.map(item => ({
						tag: item.tag,
						in: parseInt(item.in) || 0,
						out: parseInt(item.out) || 0
					}));
					
					this.$EventBus.$emit('parking_counter_updated', {
						barcode: sessionData.barcode,
						totalizers,
						deviceId: deviceId,
						recordingState: this.recording_states[deviceId]
					});
				}
				
				// Calcular estadísticas finales
				const totalEvents = sessionData.totalizer ? sessionData.totalizer.reduce((sum, item) => sum + parseInt(item.in) + parseInt(item.out), 0) : 0;
				
				// Mostrar notificación con resumen
				const notificationMsg = `Sesión finalizada en ${device.name}: ${sessionData.barcode}\nDuración: ${durationMinutes} min | Eventos: ${totalEvents}`;
				
				this.$EventBus && this.$EventBus.$emit('notifications_modal', {
					type: 'success',
					message: notificationMsg
				});
				
				// Emitir evento para el componente padre
				this.$EventBus.$emit('parking_recording_state_changed', {
					deviceId: deviceId,
					recordingState: this.recording_states[deviceId],
					action: 'stop'
				});
				
				//console.log(`✅ [PARKING] Sesión finalizada para ${device.name}`);
				
			} catch (error) {
				//console.error('❌ [PARKING] Error procesando notificación de finalización:', error);
			}
		},
	}, // methods	
	
	mounted(){
		this.onResize();
		this.syncCamVisibilityWithStore();
		
		//console.log('[PARKING] Configurando event listeners...');
		
		// Escuchar eventos de smart_event para actualizar contadores
		this.$EventBus.$on('events_smart_event', this.handleSmartEvent);
		//console.log('[PARKING] Event listener configurado para: events_smart_event');
		
		// Escuchar eventos de actualización de contadores desde event.js
		this.$EventBus.$on('update_parking_counter', this.handleCounterUpdate);
		//console.log('[PARKING] Event listener configurado para: update_parking_counter');
		
		// Escuchar eventos de detección de objetos
		this.$EventBus.$on('object_detection', this.handleObjectDetection);
		//console.log('[PARKING] Event listener configurado para: object_detection');
		
		// NUEVO: Escuchar eventos de counter desde connections.vue
		this.$EventBus.$on('events_counter', this.handleCounterEvent);
		//console.log('[PARKING] Event listener configurado para: events_counter');
		
		// Sincronizar visibilidad de cámaras con el store
		this.syncCamVisibility();
		
		// Configurar intervalos para actualizaciones periódicas
		this.emitInitialCounterUpdate(); // Emitir actualización inicial de contadores
		
		// NUEVO: Validar contadores con backend automáticamente después de F5
		this.validateAllActiveCountersOnLoad();
		
		// NUEVO: Configurar listeners de WebSocket para notificaciones de sesiones
		this.setupWebSocketListeners();
		
		// Función global para testing desde consola
		window.validateBarcode = (barcode) => {
			//console.log(`🧪 [CONSOLE-TEST] Validando barcode: ${barcode}`);
			return this.validateCountersByBarcode(barcode);
		};
		
		window.validateCurrentDevice = (deviceId) => {
			//console.log(`🧪 [CONSOLE-TEST] Validando dispositivo actual: ${deviceId}`);
			return this.validateCurrentSession(deviceId);
		};
		
		// Funciones de prueba para simular notificaciones WebSocket
		window.simulateSessionStart = (deviceId, barcode = null) => {
			//console.log(`🧪 [SIMULATE] Simulando inicio de sesión para: ${deviceId}`);
			const testBarcode = barcode || `BC${Date.now()}`;
			const simulatedData = {
				action: "session_started",
				message: `Sesión de operación iniciada para barcode: ${testBarcode}`,
				sessionData: {
					id: Math.floor(Math.random() * 1000),
					barcode: testBarcode,
					deviceId: deviceId,
					timestamp_start: Date.now().toString(),
					timestamp_end: null,
					state: 1,
					totalizer: [
						{ tag: "person", in: 0, out: 0 },
						{ tag: "vehicle", in: 0, out: 0 }
					]
				},
				timestamp: new Date().toISOString(),
				deviceId: deviceId
			};
			
			console.log('🧪 [SIMULATE] Datos simulados:', simulatedData);
			this.handleSessionStartNotification(simulatedData);
			return simulatedData;
		};
		
		window.simulateSessionEnd = (deviceId, barcode = null) => {
			//console.log(`🧪 [SIMULATE] Simulando finalización de sesión para: ${deviceId}`);
			const currentState = this.recording_states[deviceId];
			if (!currentState) {
				//console.log('⚠️ [SIMULATE] No hay sesión activa para finalizar');
				return;
			}
			
			const testBarcode = barcode || currentState.barcode;
			const startTime = typeof currentState.startedAt === 'object' ? currentState.startedAt.getTime() : parseInt(currentState.startedAt);
			const endTime = Date.now();
			
			const simulatedData = {
				action: "session_ended",
				message: `Sesión de operación finalizada para barcode: ${testBarcode}`,
				sessionData: {
					id: currentState.id || Math.floor(Math.random() * 1000),
					barcode: testBarcode,
					deviceId: deviceId,
					timestamp_start: startTime.toString(),
					timestamp_end: endTime.toString(),
					state: 2,
					totalizer: [
						{ tag: "person", in: Math.floor(Math.random() * 20), out: Math.floor(Math.random() * 15) },
						{ tag: "vehicle", in: Math.floor(Math.random() * 10), out: Math.floor(Math.random() * 8) }
					]
				},
				timestamp: new Date().toISOString(),
				deviceId: deviceId
			};
			
			//console.log('🧪 [SIMULATE] Datos simulados:', simulatedData);
			this.handleSessionEndNotification(simulatedData);
			return simulatedData;
		};
		
		//console.log('[PARKING] Componente montado correctamente');
		//console.log('🧪 [PARKING] Funciones de testing disponibles en consola:');
		//console.log('   - window.validateBarcode("BC123456789") - Valida un barcode específico');
		//console.log('   - window.validateCurrentDevice("device-id") - Valida sesión actual de un dispositivo');
		//console.log('   - window.simulateSessionStart("device-id", "barcode") - Simula inicio de sesión');
		//console.log('   - window.simulateSessionEnd("device-id", "barcode") - Simula finalización de sesión');
		//console.log('🔌 [PARKING] WebSocket listeners configurados para notificaciones en tiempo real');
	},
	beforeDestroy() {
		// Limpia los listeners de eventos
		this.$EventBus.$off('syncCamVisibility');
		this.$EventBus.$off('getCamVisibility');
		this.$EventBus.$off('objectDetected');
		this.$EventBus.$off('events_smart_event', this.handleSmartEvent);
		this.$EventBus.$off('update_parking_counter', this.handleCounterUpdate);
		this.$EventBus.$off('object_detection', this.handleObjectDetection);
		this.$EventBus.$off('events_counter', this.handleCounterEvent);
		
		// Limpiar listeners de WebSocket
		if (this.$socket) {
			//console.log('🔌 [WEBSOCKET] Limpiando listeners de sesiones...');
			this.$socket.off('server:operation_session_start');
			this.$socket.off('server:operation_session_end');
		}
		
		// Limpiar funciones globales de testing
		if (window.validateBarcode) {
			delete window.validateBarcode;
		}
		if (window.validateCurrentDevice) {
			delete window.validateCurrentDevice;
		}
		if (window.simulateSessionStart) {
			delete window.simulateSessionStart;
		}
		if (window.simulateSessionEnd) {
			delete window.simulateSessionEnd;
		}
		
		//console.log('🧹 [PARKING] Limpieza de componente completada');
	},
}; // export default

function formatForBackend(date) {
  const d = new Date(date);
  d.setMilliseconds(0); // Fuerza los milisegundos a cero
  // No forzar los segundos a cero, usar los reales
  const pad = n => n.toString().padStart(2, '0');
  return `${d.getFullYear()}/${pad(d.getMonth()+1)}/${pad(d.getDate())}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
}